import Navigation from '@/components/navigation/Navigation'
import Watch from '@/components/watch/Watch'
import WatchDashboard from './watch/dashboard'
import WatchReadings from './watch/readingsV2'
import WatchPillBoxV2 from './watch/pillboxV2'
import WatchAppointments from './watch/appointments'
import WatchHealthReports from './watch/healthreports'
import WatchMedicalDocuments from './watch/medicaldocuments'
import WatchProfile from './watch/profile'
import AppShell from '@/components/shell/AppShell'

export default [
	{
		path: '/:user_uid',
		meta: {
			requiredAuth: true
		},
		components: {
			default: AppShell
		},
		props: {
			default: true
		},
		children: [
			{
				path: 'watches/:watch_id',
				meta: {
					requiredAuth: true
				},
				components: {
					default: Watch,
					menu: Navigation
				},
				props: {
					default: (route) => ({
						user_uid: route.params.user_uid,
						watch_id: route.params.watch_id
					}),
					menu: (route) => ({
						user_uid: route.params.user_uid,
						watch_id: route.params.watch_id
					})
				},
				children: [
					{
						path: '',
						name: 'Watch',
						redirect: 'dashboard'
					},
					...WatchDashboard,
					...WatchReadings,
					...WatchPillBoxV2,
					...WatchAppointments,
					...WatchHealthReports,
					...WatchMedicalDocuments,
					...WatchProfile,
				]
			}
		]
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/watch.js